export enum PaymentStepState
{
    // Unset = "Unset",
    Awaiting = "Awaiting",
    Paid = "Paid",
    Canceled = "Canceled",
    Omitted = "Omitted",
    Error = "Error",
    Returned = "Returned",
}
